export default __webpack_public_path__ + "static/media/short.bceae94a.svg";